import React, { PureComponent } from 'react';

import { DRNInputField } from '@traveloka/district-ui';
import TouchableInputFieldWrapper from 'common/components/TouchableInputFieldWrapper/TouchableInputFieldWrapper';
import InputFieldIconWrapper from 'common/components/InputFieldIconWrapper/InputFieldIconWrapper';
import BusDeparture from 'common/res/svg/BusDeparture';
import { BUS_STATION_SELECTION_TYPE_ORIGIN } from './BusBookingSearchForm';
import BusArrival from 'common/res/svg/BusArrival';

export class BusBookingStationField extends PureComponent {
  render() {
    const { type, label, value, disabled, onPress: handlePress } = this.props;
    const icon =
      type === BUS_STATION_SELECTION_TYPE_ORIGIN ? BusDeparture : BusArrival;
    return (
      <TouchableInputFieldWrapper onPress={handlePress}>
        <InputFieldIconWrapper Icon={icon}>
          <DRNInputField
            label={label}
            value={value}
            editable={false}
            disabled={disabled}
          />
        </InputFieldIconWrapper>
      </TouchableInputFieldWrapper>
    );
  }
}

export default BusBookingStationField;
